import { render, staticRenderFns } from "./project-overview.vue?vue&type=template&id=21fe84bf"
import script from "./project-overview.ts?vue&type=script&lang=ts&external"
export * from "./project-overview.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports